<template>
    <div class="body">
        <div class="content">
            <div class="title">我该如何联系客服？</div>
            <div class="desc">
                客服工作时间为工作日9:00-18:00：您可请点击右下角的聊天窗联系在线客服
            </div>
        </div>
        <div class="content">
            <div class="title">如何添加项目？</div>
            <div class="desc">
                您所在的门店官网的项目会同步到APP内，方便您在手机内实时查看，暂时无法在APP内添加，请前往官网操作
            </div>
        </div>
        <div class="content">
            <div class="title">如何跟进客户信息？</div>
            <div class="desc">
                您可在客户管理内添加您的跟进信息，方便您随时随地管理客户
            </div>
        </div>
        <div class="content">
            <div class="title">如何注销账号？</div>
            <div class="desc">
                因APP的信息和您所在门店官网同步，请您联系在线客服或在设置-注销账号操作
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "message",
        data() {
            return {
                infos:[],
            }
        }, created() {
            this.util.title("咨询与反馈");
            (function (w, d, n, a, j) {
                w[n] = w[n] || function () {
                    (w[n].a = w[n].a || []).push(arguments);
                };
                j = d.createElement('script');
                j.async = true;
                j.src = 'https://qiyukf.com/script/3f9a2096a3b5dc05c7525429aab70eda.js';
                d.body.appendChild(j);
            })(window, document, 'ysf');
        }, methods: {

        }
    }
</script>

<style scoped>
    * {
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .body{
        background: #F7F7F7;
        padding-top: 0.2rem;

    }

    .content{
        width: 90%;
        background: #fff;
        border-radius: 4px;
        margin: 0rem auto;
        margin-bottom: 0.15rem;
        padding: 0.1rem 0.1rem;
    }

    .content .title{
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.05rem;
    }

    .content .desc{
        font-size: 0.12rem;
        font-weight: 400;
        color: #999999;
    }

</style>
